/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SeverityEnum = 'INFO' | 'WARN' | 'ERROR' | 'CRITICAL';

export const SeverityEnum = {

    INFO: 'INFO' as SeverityEnum,

    WARN: 'WARN' as SeverityEnum,

    ERROR: 'ERROR' as SeverityEnum,

    CRITICAL: 'CRITICAL' as SeverityEnum
};

